import { useMutation } from "@tanstack/react-query";

import { AmplitudeApi } from "@/api/amplitude";
import { useOpenModal } from "@/components/modal/utils/openModal";

import { CreatePhoneCallApi } from "../api/CreatePhoneCall.api";
import { CreatePhoneCallResponseDTOError } from "../models";

export const useCreatePhoneCall = () => {
  const { openModal, removeAll } = useOpenModal();

  const openErrorModal = (message: string) => {
    openModal("INFORMATION_MODAL", {
      message,
      statusReg: "fail",
    });
  };

  const openSuccessModal = (message: string) => {
    openModal("INFORMATION_MODAL", {
      message,
      statusReg: "success",
      onOkClick: removeAll,
    });
  };

  return useMutation(CreatePhoneCallApi.createPhoneCall, {
    onSuccess: (response) => {
      const errorCaseDTO = CreatePhoneCallResponseDTOError.safeParse(response);

      if (errorCaseDTO.success) {
        openErrorModal(
          "Could not execute phone call reservation. Reason: " +
            errorCaseDTO.data.requestDTO.dataMap.error,
        );
      } else {
        openSuccessModal(
          "Your phone call reservation order has been submitted for processing.",
        );
        AmplitudeApi.send({
          amplitude: "phone_calls",
        });
      }
    },
  });
};
